import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { DIRECTION_CLASS } from "components/Flex/Flex";
import RadioButton from "components/RadioButton";
import { func, number, string } from "prop-types";
import { useState } from "react";
import { pluralize } from "utils/string";

import classes from "./CascadeStatusModal.module.scss";

const countWithNoun = (count, noun) => `${count} ${pluralize(noun, count)}`;
const countText = (subsectionCount) =>
  `This section contains ${countWithNoun(subsectionCount, "sub-section")}.`;
const secondaryText = (secondaryCount) =>
  `${secondaryCount} of them already ${secondaryCount === 1 ? "has" : "have"} a status set.`;

const CascadeStatusModal = ({
  statusLabel,
  subsectionCount,
  secondaryCount = 0,
  onConfirm,
  onCancel,
}) => {
  const [cascade, setCascade] = useState(true);

  const renderOption = (label, value) => (
    <button
      type="button"
      className={classes["cascade_status_modal__option"]}
      role="radio"
      aria-checked={cascade === value}
      onClick={() => setCascade(value)}
    >
      <Flex gap={GAP_CLASS.GAP_250}>
        <RadioButton checked={cascade === value} />
        <span>{label}</span>
      </Flex>
    </button>
  );

  return (
    <Modal
      data-testid="cascade-status-modal"
      className="fade-in"
      show
      onDismiss={onCancel}
      centered
    >
      <Modal.Header>Set Status</Modal.Header>
      <Modal.Body>
        <Flex
          direction={DIRECTION_CLASS.column}
          gap={GAP_CLASS.GAP_400}
          alignItems="flex-start"
        >
          <Flex
            className={classes["cascade_status_modal__text_group"]}
            direction={DIRECTION_CLASS.column}
            gap={GAP_CLASS.GAP_200}
            alignItems="flex-start"
          >
            <p>{countText(subsectionCount)}</p>
            {secondaryCount > 0 && (
              <p className={classes["cascade_status_modal__secondary_text"]}>
                {secondaryText(secondaryCount)}
              </p>
            )}
            <p>Do you want to also set the sub-sections to {statusLabel}?</p>
          </Flex>

          <Flex
            direction={DIRECTION_CLASS.column}
            gap={GAP_CLASS.GAP_300}
            alignItems="flex-start"
          >
            {renderOption("Yes, set the status on all sub-sections", true)}
            {renderOption("No, set the status on this section only", false)}
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cascade-status-modal-cancel"
          variant={NewButtonVariant.l2}
          onClick={onCancel}
        >
          Cancel
        </NewButton>
        <NewButton
          data-testid="cascade-status-modal-confirm"
          variant={NewButtonVariant.l1}
          onClick={() => onConfirm(cascade)}
        >
          Set Status
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

CascadeStatusModal.propTypes = {
  statusLabel: string.isRequired,
  subsectionCount: number.isRequired,
  secondaryCount: number,
  onConfirm: func.isRequired,
  onCancel: func.isRequired,
};

export default CascadeStatusModal;
